import { createHttpClient } from "@intergamma/account"
import type { CustomerListResponseDto, SearchCustomerListResponseDto } from "../base-api/generated"
import type { DeleteListItemPayload } from "./types/List"

export function createListsService(MYACCOUNT_URL: string) {
  const baseClient = createHttpClient(`${MYACCOUNT_URL}/api/lists`, {
    withCredentials: true,
  })

  return {
    getLists(): Promise<SearchCustomerListResponseDto> {
      return baseClient.get<SearchCustomerListResponseDto>(`/`)
    },

    getList(listId: string): Promise<CustomerListResponseDto> {
      return baseClient.get<CustomerListResponseDto>(`/${listId}`)
    },

    deleteListItem({ itemId, listId }: DeleteListItemPayload): Promise<void> {
      return baseClient.delete(`/items/${itemId}`, {
        data: {
          listId,
        },
      })
    },
  }
}
